import React from 'react';
import AdvancedFilters, { FilterConfig } from '@components/AdvancedFilters';

/**
 * Versão mobile dos filtros de relatórios.
 * Usa o componente centralizado AdvancedFilters em modo mobile.
 */
export const MobileReportsFilters: React.FC = () => {
  const filterConfig: FilterConfig = {
    showClientFilter: true,
    showDateRangeFilter: true,
    showCategoryFilter: true,
    showPriorityFilter: true,
    showQrCodeFilter: true,
    showSimilarOnlyFilter: false, // Não mostrar em relatórios
    showAssigneeFilter: true,
    showProviderFilter: true,
    pageType: 'reports',
    variant: 'mobile',
  };

  return <AdvancedFilters config={filterConfig} />;
};

export default MobileReportsFilters;
